<template>
    <div class="makc-input-wrapper">
        <input :disabled="isDisabled" :value="modelValue" @input="updateInput" type="text">
        <div class="makc-input-errors" v-if="error">
            {{ errorMsg }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'makc-input',
    props: {
        modelValue: [String, Number],
        fieldType: {
            type: String,
            default: 'text',
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMsg: {
            type: String,
            default: '',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        updateInput(event) {
            if ( this.fieldType === 'number' ) {
                event.target.value = event.target.value.replace(/[^0-9]/g, '');
            }
            this.$emit('update:modelValue', event.target.value);
        }
    },
}
</script>

<style scoped>
    input {
        width: 100%;
        padding: 7px 10px;
        outline: none;
        border: 1px solid #b8b8b8;
    }
    input:disabled {
        background-color: #ecebeb;
    }
    .makc-input-errors {
        position: absolute;
        line-height: 1;
        color: red;
    }
    .makc-input-wrapper {
        position: relative;
    }
</style>